'use strict';

angular.module('casist.sklad')
  .controller('CennikyDetailCtrl', [
    '$scope',
    '$modalInstance',
    '$controller',
    'CennikZaznam',
    'SearchCtrl',
    'item',
    'items',
    'Karta',
    function(
      $scope,
      $modalInstance,
      $controller,
      CennikZaznam,
      SearchCtrl,
      item,
      items,
      Karta
    ) {

    $scope.items = items;
    $scope.Karta = Karta;

    $scope.RecordCtrl = $controller('RecordCtrl', {
      $scope: $scope,
      $modalInstance: $modalInstance,
      Model: CennikZaznam
    });

    var defaultItem = {
        mo: 0.0
    };

    $scope.RecordCtrl.main.init({
      endpoint: 'cennikzaznamy',
      model: 'item',
      master: item,
      list: $scope.items,
      defaultItem: defaultItem,
      searchCtrl: SearchCtrl,
      $modalInstance: $modalInstance,
    });

    if (!isEmpty(item)) {
      $scope.item = CennikZaznam.copy(copyMissing(defaultItem, item));
    } else {
      $scope.item = angular.copy(CennikZaznam.restangularize(defaultItem));
    }

    $scope.ok = function () {
      var promise = $scope.RecordCtrl.main.save();
      if (promise) {
        promise.then(function(result) {
          $modalInstance.close(result);
        });
      }
    };

   $scope.cancel = function () {
      $scope.RecordCtrl.main.dismiss();
   };

   $scope.deleteRecord = function () {
      $scope.RecordCtrl.main.remove().then(function () {
        $modalInstance.dismiss({type: 'removed', item: item});
      });
    };

    $scope.selectedKarta = function (karta) {
      $scope.item.karta_data = karta;
    };
  }]);
